import { StyleSheet, css } from 'aphrodite';
import * as React from 'react';
import { unlayerCustomCss } from '../../../models/UiUtils';

interface IProps {
	htmlContent: string;
	title?: string;
}

const styleSheet = StyleSheet.create({
	iframe: {
		border: 'none',
		display: 'block',
		height: '100%',
		width: '100%',
	},
});

const buildSrcDoc = (htmlContent: string) => {
	// Inline the unlayer custom CSS so it ships with srcDoc; the iframe sandbox
	// (no allow-same-origin) blocks parent access to contentDocument, so we
	// can't inject styles after load.
	const styleTag = `<style>${unlayerCustomCss}</style>`;
	if (/<head\b[^>]*>/i.test(htmlContent)) {
		return htmlContent.replace(/<head\b[^>]*>/i, match => `${match}${styleTag}`);
	}
	return `${styleTag}${htmlContent}`;
};

export const PublicNewsletterIframe: React.FC<IProps> = ({ htmlContent, title }) => {
	const srcDoc = React.useMemo(() => buildSrcDoc(htmlContent), [htmlContent]);

	return (
		<iframe
			className={css(styleSheet.iframe)}
			sandbox='allow-popups allow-popups-to-escape-sandbox'
			srcDoc={srcDoc}
			title={title ?? 'Newsletter'}
		/>
	);
};
